import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

// Styles
import styles from './index.module.sass';

export default function MenuLegales(props) {
  const { i18n = {}, t } = useTranslation(['footer', 'menu']);
  const { language = '' } = i18n;
  const history = useHistory();
  const location = useLocation();

  const [showMenu, setShowMenu] = useState(false);

  const { device } = props;
  const { screenSize } = device;
  console.log(screenSize, 'screensice');

  function privacy() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/privacy_policy_us');
  }

  function agreement() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/consultant_agreement_us');
  }

  function polices() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/policies_and_procedures_us');
  }

  function california() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/california_privacy_notice');
  }

  function handBook() {
    window.scrollTo(0, 0);
    // history.push('/legal/handbook_us');
    if (language.includes('es'))
      window.open(
        'https://webimages.terramarbrands.com.mx/usawebpage/documents/legals/MANUAL_CONSULTORA.pdf',
      );
    else
      window.open(
        'https://webimages.terramarbrands.com.mx/usawebpage/documents/legals/CONSULTANT_MANUAL.pdf',
      );
  }

  function testimonios() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/testimonios');
  }

  function redesSociales() {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/redesSociales');
  }

  function productosTestimonios(params) {
    window.scrollTo(0, 0);
    setShowMenu(false);
    history.push('/cart/consultancy/legal/productosTestimonios');
  }

  return (
    <div className={styles.container}>
      {screenSize === 'phone' && !showMenu && (
        <button className={styles.menuButton} onClick={() => setShowMenu(true)}>
          ☰ Menú
        </button>
      )}
      {(screenSize !== 'phone' || showMenu) && (
        <div className={`${styles.menuLateral} ${styles[screenSize]}`}>
          <div className={styles.left}>
            <div className={styles.encabezado}>&nbsp;</div>
            <hr />
            <div
              className={`${styles.link} ${
                location.pathname.includes('privacy_policy_us') ? styles.activeLink : ''
              }`}
              onClick={() => privacy()}>
              {t('privacy')}
            </div>

            <div
              className={`${styles.link} ${
                location.pathname.includes('consultant_agreement_us') ? styles.activeLink : ''
              }`}
              onClick={() => agreement()}>
              {t('consultantAgreement')}
            </div>
            <div
              className={`${styles.link} ${
                location.pathname.includes('policies_and_procedures_us') ? styles.activeLink : ''
              }`}
              onClick={() => polices()}>
              {t('policiesProcedures')}
            </div>
            <div
              className={`${styles.link} ${
                location.pathname.includes('california_privacy_notice') ? styles.activeLink : ''
              }`}
              onClick={() => california()}>
              {t('california')}
            </div>
            <div className={styles.link} onClick={() => handBook()}>
              {t('consultantManual')}
            </div>
            <div
              className={`${styles.link} ${
                location.pathname.includes('testimonios') ? styles.activeLink : ''
              }`}
              onClick={() => testimonios()}>
              {t('testimonios')}
            </div>
            <div
              className={`${styles.link} ${
                location.pathname.includes('redesSociales') ? styles.activeLink : ''
              }`}
              onClick={() => redesSociales()}>
              {t('publicacionesRedesSociales')}
            </div>
            <div
              className={`${styles.link} ${
                location.pathname.includes('productosTestimonios') ? styles.activeLink : ''
              }`}
              onClick={() => productosTestimonios()}>
              {t('publicacionesProductos')}
            </div>
          </div>
        </div>
      )}

      <div className={styles.menuCentral}>{props.children}</div>
    </div>
  );
}
